export default __webpack_public_path__ + "static/media/665.ca6b961d.jpg";